import { CREATE_LIST_CURATION_HREF, CREATE_LIST_HREF, createListSuggestionHref, withSuggestion } from "@/lib/create-list/create-list";
import { suggestionListHref } from "@/lib/suggestion-lists/suggestion-lists";

import type { SuggestionSurface } from "./pdp-types";

/*
 * The surface travels in the URL as an enum (`?de=criacao`, `SUGGESTION_SURFACE_PARAM`) and never
 * as an address: a destination read from the query string would be an open redirect. Everything
 * the surface decides is derived here, in one place, so no component carries its own `if`.
 */

/** Reads the surface from a raw query value. Anything unknown, or absent, is the public one. */
export function parseSuggestionSurface(raw: string | undefined): SuggestionSurface {
  return raw === "criacao" ? "criacao" : "publica";
}

/**
 * Where "Quero essa lista" leads from the public page: the host door, which after the terms goes
 * on to the creation carrying the chosen suggestion — its pieces come marked in the curation.
 * Someone already signed in is sent straight on by the door itself.
 */
export function adoptSuggestionHref(slug: string): string {
  return `/onboarding?next=${encodeURIComponent(withSuggestion(CREATE_LIST_HREF, slug))}`;
}

/**
 * The two addresses a surface decides for a list: where to read it, and where adopting it leads.
 * On the creation, adopting is going on to the curation — what that step's own "Quero essa lista"
 * does — and the way back stays inside the flow instead of leaving for the public site.
 */
export function suggestionSurfaceHrefs(
  slug: string,
  surface: SuggestionSurface,
): { readonly href: string; readonly adoptHref: string } {
  if (surface === "criacao") {
    return {
      href: createListSuggestionHref(slug),
      adoptHref: withSuggestion(CREATE_LIST_CURATION_HREF, slug),
    };
  }

  return { href: suggestionListHref(slug), adoptHref: adoptSuggestionHref(slug) };
}
